<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">包名信息</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>版本状态：</label>
          <el-select v-model="versionState" placeholder="Select" style="width: 10em">
            <el-option v-for="item in versionStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>包名：</label>
          <el-input type="search" placeholder="请输入包名"  v-model="searchValue" style="width: 16em;">
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
<!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
        </div>
      </div>
    </div>
    <div class="content-main">
<!--      <div class="content-button">-->
<!--        <div>-->
<!--          <el-button type="primary" @click="editPackageDialog(-1)">新建话题</el-button>-->
<!--        </div>-->
<!--        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--      </div>-->
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="packageName" label="包名" v-if="checkColList.indexOf('包名') > -1"></el-table-column>
          <el-table-column property="" label="ICP备案信息" v-if="checkColList.indexOf('ICP备案信息') > -1">
            <template #default="scope">
              <p>ICP备案号: {{scope.row.icpNumber}}</p>
              <p>Copyright © {{scope.row.publishYear}} {{scope.row.appName}}</p>
              <p>All Rights Reserved</p>
              <el-button size="small" @click="editPackageDialog(scope.$index,scope.row, 1)" type="primary">编辑</el-button>
            </template>
          </el-table-column>
          <el-table-column property="" label="广告位ID" v-if="checkColList.indexOf('广告位ID') > -1">
            <template #default="scope">
              <p>开屏广告位id: <span style="color: #3a8ee6">{{scope.row.coopenAdid}}</span></p>
              <p>签到广告位id: <span style="color: #3a8ee6">{{scope.row.signinAdid}}</span></p>
              <p>看广告任务广告位id: <span style="color: #3a8ee6">{{scope.row.taskAdid}}</span></p>
              <p>简历主页广告位id: <span style="color: #3a8ee6">{{scope.row.resumeAdid}}</span></p>
              <p>首页banner广告位id: <span style="color: #3a8ee6">{{scope.row.homeBannerAdid}}</span></p>
              <p>发现页banner广告位id: <span style="color: #3a8ee6">{{scope.row.discoveryBannerAdid}}</span></p>
              <el-button size="small" @click="editPackageDialog(scope.$index,scope.row, 2)" type="primary">编辑</el-button>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.versionState == 0?'未列入首页划卡包':scope.row.versionState == 1?'已列入首页划卡包':''}}</p>
              <el-button size="small" @click="editPackageDialog(scope.$index,scope.row, 3)" type="primary">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getPackageNamePageList } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import PackageDialog from "./components/packageDialog";

export default {
  name: "ChannelPackage",
  components: {  },
  data() {
    return {

      //刷新组
      colList: ['创建时间', '包名', 'ICP备案信息', '广告位ID', '状态'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

      searchValue: '',
      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //versionState
      versionStateArray: [
        {label:'不限', value: -1},
        {label:'未列入', value: 0},
        {label:'已列入', value: 1}
      ],
      versionState: -1,
    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchValue'] = this.searchValue;
      param['versionState'] = this.versionState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPackageNamePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editPackageDialog(idx, row, type) {
      let _title = '';
      let packageForm = {}
      if (idx > -1) {
        _title = '包名信息'
        packageForm = Object.assign({}, row);
      }else {
        _title = '包名信息'
      }
      Dialog.open({
        title: _title,
        component: PackageDialog,
        data: {
          packageForm: packageForm,
          ids: idx,
          type: type,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
